// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import getSupportListEpic from './getSupportListEpic';
import updateReadSupportEpic from './updateReadSupportEpic';
import updateSupportStatusEpic from './updateSupportStatusEpic';
import replySupportEpic from './replySupportEpic';
import createNewSupportEpic from './createNewSupportEpic';
export default [
  getSupportListEpic,
  updateReadSupportEpic,
  replySupportEpic,
  createNewSupportEpic,
  updateSupportStatusEpic
]
